import AbstractVariableStrategy from "./AbstractVariableStrategy";

export default class DefaultVariableStrategy extends AbstractVariableStrategy {
    buildVariables(queryBuilder, context) {
        queryBuilder.addFilterField('orderField', 'String');
        queryBuilder.addFilterField('first', 'Int');
        queryBuilder.addFilterField('last', 'Int');
        queryBuilder.addFilterField('after', 'String');
        queryBuilder.addFilterField('before', 'String');

        this.addVariablesFrom(context.fieldDescriptions, queryBuilder);

        super.buildVariables(queryBuilder, context);
    }

    addVariablesFrom(fieldDescriptions, toQueryBuilder) {
        const filterFields = new Map();

        for (const desc of fieldDescriptions) {
            // Agregar campos de filtro
            if (
                desc.inputDescription &&
                desc.inputDescription.component_filter &&
                desc.inputDescription.component_filter.type !== 'null' &&
                !desc.onlyForm
            ) {
                filterFields.set(
                    desc.inputDescription.component_filter.id,
                    desc.inputDescription.component_filter.getVariableType()
                );
            }
        }

        // Agregar campos de filtro específicos
        filterFields.forEach((type, name) => {
            toQueryBuilder.addFilterField(name, type);
        });
    }
}
